@let useSheet = useMobileSheet();

<div class="autocomplete-select" [class]="className">
  <p-autoComplete
    #itemSelect
    [ngModel]="_value"
    [disabled]="disabled"
    [delay]="delay"
    (completeMethod)="onCompleteMethod($event)"
    (onHide)="onSelectHide()"
    (onShow)="onSelectShow()"
    (onBlur)="onBlur()"
    (click)="useSheet && openMobilePanel()"
    [completeOnFocus]="completeOnFocus && !useSheet"
    [readonly]="useSheet"
    [forceSelection]="forceSelection"
    [suggestions]="suggestions"
    class="h--40 w100 with-filter-icon"
    appendTo="body"
    [optionLabel]="optionLabel"
    [placeholder]="placeholder"
    (onSelect)="selectOption($event)"
    (onClear)="clearOption()"
    [virtualScrollItemSize]="25"
    [autoOptionFocus]="true"
    [panelStyleClass]="useSheet ? 'hidden' : 'autocomplete-select-panel'"
    inputStyleClass="autocomplete-select-input"
  >
    <ng-template let-param pTemplate="item">
      <div class="option-item text-14 flex align-items-center gap-8">
        @if (param.customIcon) {
          <ng-container
            [ngComponentOutlet]="param.customIcon"
            [ngComponentOutletInputs]="{
              width: 20,
              height: 20,
              color: 'var(--icon-color)',
            }"
          ></ng-container>
        }
        <div>{{ param[optionLabel] }}</div>
      </div>
    </ng-template>
    <ng-template pTemplate="empty">
      <div class="option-item text-14">
        <div>{{ 'common.no-results' | translate }}</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <div class="autocomplete-icon">
    <i (click)="onClickDropdown()" [class]="filterBtnStyleClass || ''"></i>
  </div>
</div>

@if (useSheet) {
  <app-autocomplete-sheet
    [suggestions]="suggestions"
    [optionLabel]="optionLabel"
    [completeOnFocus]="completeOnFocus"
    [delay]="delay"
    [heading]="mobilePanelTitle"
    [placeholder]="placeholder"
    (searchChange)="onCompleteMethod({ query: $event })"
    (optionSelect)="selectMobileOption($event)"
    (closed)="completeMethod.emit('')"
  ></app-autocomplete-sheet>
}
